import { Component, ReactNode,useCallback } from "react";

interface ErrorBoundaryProps{
    children: ReactNode;
}
interface ErrorBoundaryState{
    hasError:boolean ;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps){
      super(props);
      this.state = { hasError: false };
    }  
    
    static getDerivedStateFromError() { //error: any
      return { hasError: true };
    }
  
    componentDidCatch(error: any, errorInfo: any) {
      console.log(`<<<<<<, send error to api ${error} , <<<<${errorInfo}`);
      this.postErrorToServer(error, errorInfo);
    }

    postErrorToServer(error : any, errorInfo: any) {
        fetch('/api/Log', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            error: error.toString(),
            errorInfo : errorInfo.componentStack
          }),
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to log error to server');
          }
        })
        .catch(error => {
          console.error('Error logging to server:', error);
        });
      }
  
    render() {
      if (this.state.hasError) {
        return <h1>Something went wrong. contact system administrator</h1>;
      }
  
      return this.props.children; 
    }
  }

  export default ErrorBoundary